import React, { useEffect, useState, useContext } from "react";
import { HomeyApiContext } from "lib/HomeyApiContext";

import { AthomCloudAPI } from "homey-api";

const cloudApi = new AthomCloudAPI({
  clientId: "6879db5e23e5cc19f94556c4",
  clientSecret: "14e2ca74a3e45750f16eb360fc0431d9",
  redirectUrl: window.location.origin,
});

const Login = ({ userInfo, setUserInfo, setIsLoading }) => {
  const { setHomeyApi } = useContext(HomeyApiContext);

  const [authError, setAuthError] = useState(null);

  const startAuth = async () => {
    const url = cloudApi.getLoginUrl();
    window.location.href = url;
  };

  useEffect(() => {
    const runAuthFlow = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");

      if (!code) return;

      setIsLoading(true);
      try {
        await cloudApi.authenticateWithAuthorizationCode({ code });
        const user = await cloudApi.getAuthenticatedUser();
        const homey = user.getFirstHomey();
        const _homeyApi = await homey.authenticate();
        setHomeyApi(_homeyApi);

        setUserInfo({
          email: user.email,
          homeyId: homey.id,
          homeyName: homey.name,
          remoteUrl: homey.remoteUrl,
        });
        localStorage.setItem(
          "homey_auth",
          JSON.stringify({
            email: user.email,
            homeyId: homey.id,
            homeyName: homey.name,
            remoteUrl: homey.remoteUrl,
          })
        );
        // history 정리 (code 제거)
        window.history.replaceState({}, "", window.location.pathname);
      } catch (err) {
        console.error("인증 실패", err);
        setAuthError(err.message || "Unknown error");
      } finally {
        setIsLoading(false);
      }
    };

    runAuthFlow();
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      const loggedIn = await cloudApi.isLoggedIn();
      console.log('checkAuth loggedIn : ', loggedIn);

      if (!loggedIn) {
        if (cloudApi.hasAuthorizationCode()) {
          console.log('checkAuth hasAuthorizationCode');
          try {
            const token = await cloudApi.authenticateWithAuthorizationCode();
            console.log("토큰:", token);
          } catch (err) {
            console.error('authenticateWithAuthorizationCode err : ', err);
          }
        } else {
          // 자동 리다이렉트 가능
          // window.location.href = cloudApi.getLoginUrl();
          return;
        }
      } else {
        const saved = localStorage.getItem("homey_auth");
        if (saved) {
          try {
            const parsed = JSON.parse(saved);
            setUserInfo(parsed);

            const user = await cloudApi.getAuthenticatedUser();
            const homey = user.getFirstHomey();
            const _homeyApi = await homey.authenticate();
            setHomeyApi(_homeyApi);
          } catch (e) {
            localStorage.removeItem("homey_auth"); // 파싱 실패 시 정리
          }
        }
      }
    };

    checkAuth();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "0.5rem",
        position: "absolute",
        top: 20,
        right: 20,
      }}
    >
      <button
        onClick={startAuth}
        style={{
          backgroundColor: "#10b981",
          color: "#fff",
          padding: "0.5rem 1rem",
          borderRadius: "0.375rem",
          border: "none",
        }}
      >
        {userInfo ? "Re-login" : "Login"}
      </button>
      {userInfo && (
        <button
          onClick={() => {
            console.log("Logout")
            localStorage.removeItem("homey_auth");
            setUserInfo(null);
            cloudApi.logout();
          }}
          style={{
            backgroundColor: "#ef4444",
            color: "#fff",
            padding: "0.5rem 1rem",
            borderRadius: "0.375rem",
            border: "none",
          }}
        >
          Logout
        </button>
      )}
    </div>
  );
};

export default Login;
